import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const businessBadge = css`
  padding-inline-start: ${spacing(0.5)}; // 4px
`
export const sizeSubTitle = css`
  font-size: 9px;
  line-height: 12px;
`
export const row = css`
  padding-block-end: ${spacing(2)}; // 16px
`
